import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SidebarNav from './SidebarNav';

const DashboardLayout = ({
  navSections,
  workspaceLabel,
  sidebarBottom,
  bell,
  children,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = React.useState(false);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#F8FAFC' }}>
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        <SidebarNav
          sections={navSections}
          brand="Workmate"
          workspaceLabel={workspaceLabel}
          bottom={sidebarBottom}
          bell={bell}
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
        />

        <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
          {isMobile ? (
            <Box
              sx={{
                px: 2,
                py: 1.25,
                borderBottom: theme => `1px solid ${theme.palette.divider}`,
                bgcolor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1,
                position: 'sticky',
                top: 0,
                zIndex: 1200,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                <IconButton
                  onClick={() => setMobileOpen(true)}
                  edge="start"
                  sx={{
                    mr: 0.25,
                    borderRadius: 2,
                    color: 'text.primary',
                    '&:hover': { bgcolor: 'rgba(15, 23, 42, 0.06)' },
                  }}
                  aria-label="Open navigation"
                >
                  <MenuRoundedIcon />
                </IconButton>
                <Box sx={{ minWidth: 0 }}>
                  <Typography sx={{ fontWeight: 900, lineHeight: 1.1 }}>Workmate</Typography>
                  {workspaceLabel ? (
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {workspaceLabel}
                    </Typography>
                  ) : null}
                </Box>
              </Box>
              {bell ? <Box sx={{ flexShrink: 0 }}>{bell}</Box> : null}
            </Box>
          ) : null}

          <Box
            component="main"
            sx={{
              flex: 1,
              minWidth: 0,
              px: { xs: 1.25, md: 3 },
              py: 3,
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;

